// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"6302648d","186":"3e5a5aac","409":"0a59aa16","807":"3e5a5aac","815":"3e5a5aac"}[chunkId] + ".chunk.css";
};